import React from "react";
import { styled } from "styled-components";
import CheckBox from "../CheckBox/Checkbox.component";
import { GreenCheck } from "../../../public/assets";

interface TransferPeriod {
  period: string;
  isActive: boolean;
  onClick: () => void;
}
const TransferPeriod: React.FC<TransferPeriod> = ({
  period,
  isActive,
  onClick,
}) => {
  return (
    <>
      <PeriodWrapper onClick={onClick} isActive={isActive}>
        <span>{period}</span>
        {isActive && <Icon src="/assets/icons/greenCheck.svg" />}
      </PeriodWrapper>
    </>
  );
};

export default TransferPeriod;

export const PeriodWrapper = styled.div<{ isActive: boolean }>`
  width: 6.625rem;
  height: 6rem;
  border: 1px solid ${(props) => (props.isActive ? "#2BD02D" : "#f0f2f4")};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-radius: 0.6rem;
  padding: 0.5rem;
  background-color: ${(props) => (props.isActive ? "#CCF4CD" : "")};
  position: relative;
  box-sizing: border-box;
  span {
    @media screen and (max-width: 767px) {
      width: 6.625rem;
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 5%;
  right: 5%;
`;
